export default __webpack_public_path__ + "static/media/anil.6590292f.png";